module.exports = __webpack_public_path__ + "static/media/13.b5b6b648.jpg";